import { ROUTE_PATHS } from "../../../../constants/app.constants";
import SecStackReportReviewPage from "../../../sec-stack-report/report-page/sec-stack-review";
import styles from "./index.module.scss";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

const MspReport = () => {
  const { accountId } = useParams();

  const previewPath = useMemo(() => ROUTE_PATHS.subscriptionPortalPages.mspStackReportPreviewShare(accountId), [accountId]);
  const backPath = useMemo(() => ROUTE_PATHS.subscriptionPortalPages.mspAccountDetails(accountId), [accountId]);

  return (
    <div className={styles.container}>
      <SecStackReportReviewPage previewPath={previewPath} backPath={backPath} />
    </div>
  )
}

export default MspReport;
